import Button from '@/components/content/button/Button';
import InfoIcon from '@/assets/icons/content/info.svg';
import { POSTHOG_EVENTS } from '@/lib/posthog/events';
import { trackEvent } from '@/lib/posthog/helpers';

interface ContactSupportProps {
  iconPosition?: 'left' | 'right';
}

const ContactSupport = ({ iconPosition = 'right' }: ContactSupportProps) => {
  const handleClick = () => {
    trackEvent(POSTHOG_EVENTS.HELP_CENTER_OPEN, { source: 'contact_support' });
    window.open(
      'https://help.quointelligence.eu/mercury-help-center',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Button
      onClick={handleClick}
      leftSection={iconPosition === 'left' ? <InfoIcon width={18} height={18} /> : undefined}
      rightSection={iconPosition === 'right' ? <InfoIcon width={18} height={18} /> : undefined}
    >
      Help Center
    </Button>
  );
};

export default ContactSupport;
